var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert",
    class: _vm.containerCss,
    attrs: {
      "uk-alert": ""
    }
  }, [(_vm.icon) ? _c('div', {
    staticClass: "alert__icon"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "alert__message"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.message))])], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b98f316c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/AlertBox.vue
// module id = 2100
// module chunks = 0